export enum BasketButtonState {
  CheckOrder,
  PlaceOrder,
  SendForReview,
  WaitingForReview,
  RejectOrCheck,
  RejectOrPlace,
}
